import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { SubmissionBaseQuestionPreview } from './base-question.component';
import styled from '@xstyled/styled-components';
import { Space, Input, Row, Col } from 'antd';
import { styleVariables } from '@lib/common';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AnswerGroup = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 80%;\n"])));
var AnswerItem = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  width: 70%;\n"])));
var OrderNumericalColumn = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  min-width: 28px;\n  margin-right: 8px;\n\n  text-align: center;\n"])));
var AnswerValueColumn = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"])));
var StyledFillInBlankAnswerInput = styled(Input)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border-radius: 8px;\n\n  color: ", ";\n\n  cursor: not-allowed;\n"])), styleVariables.colors.gray13);
var StyledCorrectAnswerText = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  margin-left: 12px;\n"])), function (props) {
  return props.$error ? props.theme.color.fontColorError : props.theme.color.fontColorSuccess;
});
export var SubmissionFillInBlankQuestionPreview = function SubmissionFillInBlankQuestionPreview(props) {
  var question = props.question,
      isSkipped = props.isSkipped,
      fillInBlankGroupAnswer = props.answer,
      label = props.label;

  var renderAnswers = function renderAnswers() {
    return question.answers.map(function (answer, index) {
      var _correspondAnswerBlan;

      var correspondAnswerBlank = fillInBlankGroupAnswer.answers.find(function (a) {
        return a.answerBlankId === answer.id.toString();
      });
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(AnswerItem, {
          children: [/*#__PURE__*/_jsxs(OrderNumericalColumn, {
            children: ["(", index + question.index, ")"]
          }), /*#__PURE__*/_jsx(AnswerValueColumn, {
            children: /*#__PURE__*/_jsx(StyledFillInBlankAnswerInput, {
              readOnly: true,
              value: correspondAnswerBlank ? (_correspondAnswerBlan = correspondAnswerBlank.value) === null || _correspondAnswerBlan === void 0 ? void 0 : _correspondAnswerBlan.text : ''
            })
          })]
        }, answer.id.toString()), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            span: 24,
            children: /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
              $error: false,
              children: ["(", label.correctAnswers, ": ", answer.description, ")"]
            })
          })
        })]
      });
    });
  };

  return /*#__PURE__*/_jsx(SubmissionBaseQuestionPreview, _objectSpread(_objectSpread({}, props), {}, {
    isSkipped: isSkipped,
    isEssayQuestion: true,
    children: /*#__PURE__*/_jsx(AnswerGroup, {
      direction: "vertical",
      size: "middle",
      children: renderAnswers()
    })
  }));
};